import React from "react";
import ErrorMessage from "../../buyflow/partials/error";
import FieldLabel from "../../../components/label";
import CallToAction from "../partials/cta";
import { withStyles } from "@mui/styles";
import { Box, TextField } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { SLUG_LOGIN, SLUG_OTP } from "../../../constants";

function AadhaarInputForm({
  classes: { containerButton, formGroup },
  form,
  errorMessage,
  errors,
  handleChange,
  isFormSubmitted,
  onSubmit,
  validateInputLength,
}) {
  return (
    <form noValidate autoComplete="off" onSubmit={onSubmit}>
      <Box className={formGroup}>
        <FieldLabel label={"Aadhaar Number*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.aadhaar_number}
          name="aadhaar_number"
          onInput={validateInputLength}
          onChange={handleChange}
          autoComplete="off"
          helperText={errorMessage.aadhaar_number}
          inputMode="numeric"
          fullWidth
          disabled={isFormSubmitted || form.step === SLUG_OTP}
        />
      </Box>

      {form.step === SLUG_LOGIN && <ErrorMessage errors={errors} />}

      {form.step === SLUG_LOGIN && (
        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          <CallToAction
            buttonType={"submit"}
            errorMessage={errorMessage}
            form={form}
            isFormSubmitted={isFormSubmitted}
            text={"Generate OTP"}
            handleClick={() => {}}
            marginTopClass={"marginTop10"}
            isDisabled={
              isFormSubmitted ||
              !form.aadhaar_number ||
              errorMessage.aadhaar_number
            }
          />
        </Box>
      )}
    </form>
  );
}

export default withStyles(useStyles, { withTheme: true })(AadhaarInputForm);
